import { render, staticRenderFns } from "./MaterialDetection.vue?vue&type=template&id=0b2c6097&scoped=true&"
import script from "./MaterialDetection.vue?vue&type=script&lang=js&"
export * from "./MaterialDetection.vue?vue&type=script&lang=js&"
import style0 from "./MaterialDetection.vue?vue&type=style&index=0&id=0b2c6097&scoped=true&lang=css&"
import style1 from "./MaterialDetection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2c6097",
  null
  
)

export default component.exports